import { render, staticRenderFns } from "./ChangePw.vue?vue&type=template&id=160aed4e&"
import script from "./ChangePw.vue?vue&type=script&lang=js&"
export * from "./ChangePw.vue?vue&type=script&lang=js&"
import style0 from "./ChangePw.vue?vue&type=style&index=0&id=160aed4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports